import React, { useCallback } from 'react';
import { PdfPreviewDialog } from './PdfPreviewDialog';
import { useAdminData } from '../../contexts/AdminDataContext';
import { quoteFileName, quotePdfBytes } from '../../utils/quotePdf';
import type { Quote } from '../../types/quote';
interface Props {
  quote: Quote;
  onClose: () => void;
}

/** Viser den færdige PDF — præcis samme fil som download og mailvedhæftning. */
export function QuotePdfPreview({
  quote,
  onClose
}: Props) {
  const {
    settings
  } = useAdminData();
  const build = useCallback(() => quotePdfBytes(quote, settings), [quote, settings]);
  return <PdfPreviewDialog title="Tilbud" fileName={quoteFileName(quote.quoteNumber)} build={build} onClose={onClose} data-id="element-458" data-mp="3n8mgy6pq9sff" />;
}